import { Button } from "@novaescola/eva-react-v2/lib/Button"
import { Link } from "@novaescola/eva-react-v2/lib/Link"
import { Typography } from "@novaescola/eva-react-v2/lib/Typography"
import axios from "axios"
import Cookies from "js-cookie"
import React, { useEffect, useState } from "react"

export function MENECardToConfirmUserRegion({ sectionTitle }) {
	const [clicked, setClicked] = useState(false)
	const [token, setToken] = useState(null)
	const [regionInformed, setStateInformed] = useState(false)

	const [region] = useState(() => {
		if (sectionTitle?.trim() === "Olá, professora. Olá, professor gaúcho.") {
			return "Rio Grande do Sul"
		}

		if (sectionTitle?.trim() === "Um novo material para você, mato-grossense") {
			return "Mato Grosso"
		}
	})

	async function putAddress(regionAcronym) {
		try {
			await axios.put(
				"https://account.novaescola.org.br/platform/userAddress",
				{
					token,
					estado: regionAcronym,
				}
			)
		} catch (_) {
			return
		}
	}

	async function saveUserInfo(option) {
		setClicked(true)

		if (token && option) {
			await putAddress(region === "Rio Grande do Sul" ? "RS" : "MT")
		} else if (!token && option) {
			Cookies.set("ane_lp_estado", region === "Rio Grande do Sul" ? "RS" : "MT")
		}

		Cookies.set("ane_lp_estado_informado", true)
	}

	useEffect(() => {
		setToken(Cookies.get("Bearer"))
		setStateInformed(Cookies.get("ane_lp_estado_informado") === "true")
	}, [])

	useEffect(() => {
		async function saveState() {
			const regionAcronym = Cookies.get("ane_lp_estado")
	
			if (token && regionInformed && regionAcronym) {
				await putAddress(regionAcronym);
	
				Cookies.remove("ane_lp_estado")
			}
		}

		saveState()
	}, [token, regionInformed])

	return region && !regionInformed ? (
		<div className="eva-card eva-bg-branco eva-margin-bottom-2 mene-region-card">
			<div className="eva-card-info">
				{!clicked ? (
					<div className="row">
						<div className="col-sm-7">
							<Typography variant="body" size={1} asChild>
								<p>Queremos te conhecer! Você é professor do {region}?</p>
							</Typography>
						</div>
						<div className="col-sm-5 ai-center col-right">
							<div className="row jc-space-evenly">
								<Button
									variant="primary"
									size="medium"
									onClick={() => saveUserInfo(true)}
									asChild
								>
									<p>Sim <i className="far fa-thumbs-up icon-right"></i></p>
								</Button>
								<Button
									variant="primary"
									size="medium"
									onClick={() => saveUserInfo(false)}
									asChild
								>
									<p>Não <i className="far fa-thumbs-down icon-right"></i></p>
								</Button>
							</div>
						</div>
					</div>
				) : (
					<Typography variant="body" size={1} asChild>
						<p>
							Obrigado! Essa informação é muito importante para nós. <br />
							<Link variant="azul" asChild>
								<a
									href={
										token
											? "https://novaescola.org.br/editar-perfil"
											: `https://novaescola.org.br/entrar?voltar=${window.location.href}`
									}
								>
									Clique aqui para nos contar mais sobre você.
								</a>
							</Link>
						</p>
					</Typography>
				)}
			</div>
		</div>
	) : null
}
